'use client';

import { useEffect } from 'react';

export default function JsonLd() {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Pekalen Rafting',
      description: 'Operator Resmi Arung Jeram Sungai Pekalen Probolinggo - Partner & Agent Program',
      url: 'https://pekalenrafting.com',
      logo: 'https://pekalenrafting.com/image/logo-black.webp',
      image: 'https://pekalenrafting.com/image/hero-new.webp',
      telephone: '+6282244440926',
      email: 'partner@pekalenrafting.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Probolinggo',
        addressRegion: 'Jawa Timur',
        addressCountry: 'ID',
      },
      sameAs: [
        'https://www.instagram.com/pekalenrafting',
        'https://www.facebook.com/pekalenrafting',
      ],
      offers: {
        '@type': 'Offer',
        name: 'Program Agent & Mitra Pekalen Rafting',
        description: 'Komisi hingga 25%, Training Gratis, Bonus & Insentif',
        url: 'https://pekalenrafting.com',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    script.id = 'json-ld-schema';

    // Remove existing script if any
    const existing = document.getElementById('json-ld-schema');
    if (existing) {
      existing.remove();
    }

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('json-ld-schema');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return null;
}
